import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Login from './components/Login';

import VehicleRegistrationDashboard from './components/VehicleRegistrationDashboard';
import DocumentViewer from './components/DocumentViewer';
import DocumentList from './components/DocumentList';
import TokenExpiredNotification from './components/TokenExpiredNotification';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <VehicleRegistrationDashboard />
                </ProtectedRoute>
              }
            />

            {/* Route public cho danh sách tài liệu */}
            <Route path="/documents-list" element={<DocumentList />} />

            {/* Route public cho xem tài liệu qua QR */}
            <Route path="/documents/:qrCode" element={<DocumentViewer />} />

            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>

          {/* Thông báo token hết hạn */}
          <TokenExpiredNotification />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
